import {tv} from 'tailwind-variants'
import {grid, gridItem} from '~/design-system/foundations'
import HgArticleHeroText, {
  type HgArticleHeroTextProps,
} from '~/design-system/hg/components/HgArticleHeroText'
import {type AuraColorToken} from '~/design-system/hg/tokens/colors'
import {getHexValueFromToken} from '~/design-system/hg/tokens/colors/utils'

export type HgArticleHeroNoAssetOptionalBackground = {
  level: 'low'
  backgroundColorToken?: AuraColorToken
}

export type HgArticleHeroNoAssetRequiredBackground = {
  level: 'medium' | 'high'
  backgroundColorToken: AuraColorToken
}

type HgArticleHeroNoAssetBackgroundProps =
  | HgArticleHeroNoAssetOptionalBackground
  | HgArticleHeroNoAssetRequiredBackground

export type HgArticleHeroNoAssetProps = {
  assetType: 'none'
  className?: string
} & HgArticleHeroTextProps &
  HgArticleHeroNoAssetBackgroundProps

const hgArticleHeroNoAssetVariants = tv({
  slots: {
    outerWrapper: 'pt-blog-navbars-height',
    innerWrapper: grid({className: 'mx-auto place-items-center'}),
  },
  variants: {
    level: {
      high: {
        innerWrapper: 'h-screen',
      },
      medium: {
        innerWrapper: 'pt-s8',
      },
      low: {
        innerWrapper: 'pt-s8',
      },
    },
    hasBackgroundColor: {
      true: {
        outerWrapper: 'bg-[var(--background)] pb-s8',
      },
    },
  },
})

export default function HgArticleHeroNoAsset({
  backgroundColorToken,
  className,
  ...props
}: HgArticleHeroNoAssetProps) {
  const backgroundColor = getHexValueFromToken(backgroundColorToken)
  const {outerWrapper, innerWrapper} = hgArticleHeroNoAssetVariants({
    level: props.level,
    hasBackgroundColor: !!backgroundColor,
  })
  return (
    <div
      className={outerWrapper()}
      style={{'--background': backgroundColor} as React.CSSProperties}
    >
      <div className={innerWrapper({className})}>
        <div
          className={gridItem({
            size: 'max',
            className: 'flex items-center sm:col-span-8 sm:col-start-3',
          })}
        >
          <HgArticleHeroText
            classNames={{
              container: 'md:grid md:grid-cols-8 md:gap-x-16 lg:grid-cols-12',
              tag: 'md:col-span-full',
              heading: 'md:col-span-full',
              subheading:
                'md:col-span-6 md:col-start-2 lg:col-span-8 lg:col-start-3',
            }}
            {...props}
          />
        </div>
      </div>
    </div>
  )
}
